import { components } from "react-select";
import type { SelectOption } from "types/api.types";

export interface SupplierSelectOption extends SelectOption {
  code?: string;
}

export function SupplierOption(props: any) {
  const data = props.data as SupplierSelectOption;
  return (
    <components.Option {...props}>
      <div className="d-flex flex-column py-1">
        <span className="fw-medium text-body">{data.label}</span>
        {data.code ? <small className="text-muted">{data.code}</small> : null}
      </div>
    </components.Option>
  );
}

export function SupplierSingleValue(props: any) {
  const data = props.data as SupplierSelectOption;
  return (
    <components.SingleValue {...props}>
      <span className="d-inline-flex align-items-center gap-1 text-truncate">
        <span className="text-truncate">{data.label}</span>
        {/* {data.code ? (
          <span className="text-muted small text-truncate">· {data.code}</span>
        ) : null} */}
      </span>
    </components.SingleValue>
  );
}
